// extracted by mini-css-extract-plugin
export default {"backdrop":"InputErrorModal_backdrop__y879s","modal":"InputErrorModal_modal__yMCxm","footer":"InputErrorModal_footer__l41qj"};